import React, { useState } from 'react';

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Input,
  Button,
  VStack,
  Text,
  FormControl,
  FormHelperText,
  FormLabel,
  FormErrorMessage,
} from '@chakra-ui/react';
import { validateSyntax } from '../../helpers/validateEmail';
import { useMarketPlaceEmailEnterMutation } from '../../generated/graphqlModels';

interface LeadGenerationModalProps {
  program: string;
  download: () => void;
  close: () => void;
  isOpen: boolean;
}

const LeadGenerationModal: React.FC<LeadGenerationModalProps> = (props) => {
  const { download, program, isOpen, close } = props;
  const [email, setEmail] = useState<string>();
  const [saveEmail] =
    useMarketPlaceEmailEnterMutation();

  const initialRef = React.useRef(null);

  const valid = email != null && email.length > 0 && validateSyntax(email);

  const saveEmailAndDownload = () => {
    if (valid) {
      saveEmail({
        variables: { data: { email, data: { programs: [program] } } },
      }).then((res) => {
        if (res.errors == null) {
          localStorage.setItem('leadEmail', email);
        }
        download();
        close();
      });
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={close}
      isCentered
      initialFocusRef={initialRef}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{program}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack align="start" spacing={0} gap={4}>
            <Text>Please enter your email address to download.</Text>
            <FormControl>
              <FormLabel>Email address</FormLabel>
              <Input
                type="email"
                ref={initialRef}
                placeholder="Email"
                onChange={(event: any) => setEmail(event.target.value)}
                value={email}
              />
              {!valid && (
                <FormErrorMessage>Email is required.</FormErrorMessage>
              )}
            </FormControl>
          </VStack>
        </ModalBody>

        <ModalFooter>
          <Button
            colorScheme="stemiRed"
            disabled={!valid}
            onClick={saveEmailAndDownload}
          >
            Download
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default LeadGenerationModal;
